"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _NavSearch = _interopRequireDefault(require("../NavSearch/NavSearch"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "relative",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  section: {
    height: theme.spacing(8),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  primaryToggle: {
    width: theme.spacing(6)
  },
  secondaryToggle: {
    width: theme.spacing(6)
  },
  button: {
    color: "inherit"
  },
  content: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    justifyContent: props => {
      return props.justifyContent;
    },
    height: theme.spacing(8),
    margin: theme.spacing(1)
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    fontWeight: "bold",
    color: props => {
      return theme.palette.header && theme.palette.header.title || theme.palette.primary.contrastText;
    }
  },
  divider: {
    backgroundColor: theme.palette.primary.contrastText,
    width: "1px",
    height: theme.spacing(3),
    opacity: 0.85,
    margin: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      display: "none"
    }
  },
  subtitle: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    fontWeight: "normal",
    opacity: 0.85,
    [theme.breakpoints.down('xs')]: {
      display: "none"
    }
  }
}));

const AppMenuToggle = ({
  menu,
  onToggle
}) => {
  const classes = useStyles();

  if (!menu) {
    return false;
  }

  return _react.default.createElement(_IconButton.default, {
    className: classes.button,
    onClick: onToggle
  }, _react.default.createElement(_Menu.default, null));
};

const AppSearchToggle = ({
  search,
  onToggle
}) => {
  const classes = useStyles();

  if (!search || search.disabled) {
    return false;
  }

  return _react.default.createElement(_IconButton.default, {
    className: classes.button,
    onClick: onToggle
  }, _react.default.createElement(_Search.default, null));
};

const AppIdentifier = ({
  className,
  expanded,
  menu,
  search,
  title,
  subtitle,
  justifyContent = "center",
  onToggle
}) => {
  const classes = useStyles({
    justifyContent
  });

  const toggleSearch = () => {
    search && search.onToggle && search.onToggle() || onToggle && onToggle('search');
  };

  const toggleMenu = () => {
    menu && menu.onToggle && menu.onToggle() || onToggle && onToggle('menu');
  };

  return _react.default.createElement("section", {
    className: className || classes.root,
    "aria-expanded": expanded
  }, _react.default.createElement("div", {
    className: classes.section
  }, _react.default.createElement("div", {
    className: classes.primaryToggle
  }, menu && _react.default.createElement(AppMenuToggle, {
    menu: menu,
    onToggle: toggleMenu
  }), !menu && _react.default.createElement(AppSearchToggle, {
    search: search,
    onToggle: toggleSearch
  })), _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement(_Typography.default, {
    component: "h1",
    className: classes.title,
    nowrap: true
  }, title), title && subtitle && _react.default.createElement("div", {
    className: classes.divider
  }), _react.default.createElement(_Typography.default, {
    component: "h2",
    className: classes.subtitle,
    nowrap: true
  }, subtitle)), _react.default.createElement("div", {
    className: classes.secondaryToggle
  }, menu && _react.default.createElement(AppSearchToggle, {
    search: search,
    onToggle: toggleSearch
  }))));
};

var _default = AppIdentifier;
exports.default = _default;
module.exports = exports.default;